import React, { createContext, useContext, useCallback } from "react";
import { useDispatch } from "react-redux";
import { showHUD } from "common/src/actions/hudactions";

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    // Fallback to prevent crash if provider is missing during transition
    return {
      showSuccess: () => console.warn("AlertProvider missing"),
      showError: () => console.warn("AlertProvider missing"),
      showWarning: () => console.warn("AlertProvider missing"),
      showInfo: () => console.warn("AlertProvider missing"),
      showAlert: () => console.warn("AlertProvider missing"),
    };
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const dispatch = useDispatch();

  const showAlert = useCallback(
    (message, severity = "info") => {
      dispatch(showHUD(message, severity));
    },
    [dispatch],
  );

  const showSuccess = useCallback(
    (message) => showAlert(message, "success"),
    [showAlert],
  );
  const showError = useCallback(
    (message) => showAlert(message, "error"),
    [showAlert],
  );
  const showWarning = useCallback(
    (message) => showAlert(message, "warning"),
    [showAlert],
  );
  const showInfo = useCallback(
    (message) => showAlert(message, "info"),
    [showAlert],
  );

  return (
    <AlertContext.Provider
      value={{ showAlert, showSuccess, showError, showWarning, showInfo }}
    >
      {children}
    </AlertContext.Provider>
  );
};
